import type { FaireProductEntity } from "../../entity_types/product";

export const p_m5f9ntrc42: FaireProductEntity = {
  token: "p_m5f9ntrc42",
  type: "product",
  name: "66 Glossy Striped Large Tote Bag",
  brandToken: "b_fpqcwkn7v8",
  brandName: "66DISCO",
  imageUrl:
    "https://cdn.faire.com/fastly/f5e7cc691c962cebe542f2eeafb8176b756aa122648cd436aa002a32d8984395.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d4ae971e16883af96a9a373c02137e3ac16c5b130f15de6462faaa890e09e57.jpeg",
    "https://cdn.faire.com/fastly/7c24530910528d4a224dfb5f99b23ae8e8f73d80f5fc867b9f95735e49236371.jpeg",
    "https://cdn.faire.com/fastly/79c5a58cc16514a8ce4bf9a22a08424165d6afcd22c90af4cb603e266ed646b9.jpeg",
    "https://cdn.faire.com/fastly/dc86233136a7ef4e0cab8dfdffa9130b114bfcdd5603d06ae4c1630047d9903a.jpeg",
    "https://cdn.faire.com/fastly/b763eadf2a9ee91a7f274035bcdafd4b50ccbe3fcede101cbb3d992de58e5771.jpeg",
    "https://cdn.faire.com/fastly/0fafcc1bc379174e4864bd2e2d7d8731a8094ca23d904b992d12b3e290037981.jpeg",
    "https://cdn.faire.com/fastly/5eb59af4ddbc2ce469f5a85b6de373ee615c9ccd7c9a5a78a21065624496e5f6.jpeg",
    "https://cdn.faire.com/fastly/9a3ebd0163a46f8ff8a64b396362a519d089f66c789bf59944d299758b6d875d.jpeg",
    "https://cdn.faire.com/fastly/6dc9907142f85b3ef9b586e918dda03d12d29e18259d6fd26190acdd55ff1039.jpeg",
    "https://cdn.faire.com/fastly/12238e792de0359b41e81bf4e41b59b8e8db05b34ec836d87cc4717f6b13223e.jpeg",
    "https://cdn.faire.com/fastly/97d421a7585729610e25c49527b67896a57e77e14bce1acb8fad520671d7cd97.jpeg",
    "https://cdn.faire.com/fastly/89c0662c16fa866ed45ba57acb6c8de1945e99bf3163d20deca6e4324d30581a.jpeg",
    "https://cdn.faire.com/fastly/75d4d34e47b2d98572ec65eb79cff94d0960a1aa384379044a29d076456b9c06.jpeg",
    "https://cdn.faire.com/fastly/85f5e49293241e271fee14ed73b7e5d8df95b8d5fd91a2f395e35d3bedd88ddc.jpeg",
    "https://cdn.faire.com/fastly/8b98523ba6ea6a7fd490d99b0a2e729d26e7d4c708669e125085b51498751e5e.jpeg",
    "https://cdn.faire.com/fastly/4ccc7fdee5dd35b7be04df9a2c1f8f13d1e839c8c67d51dc1f6a5a6df8e0c98b.jpeg",
    "https://cdn.faire.com/fastly/644b1116394d3064a9c21f6966b00671b406619bbe01832a16771edcd38945a6.jpeg",
    "https://cdn.faire.com/fastly/818acf7a6f2ed260339cff5189bfd2bf5984ba4a1b0615d91681f714995ddd01.jpeg",
    "https://cdn.faire.com/fastly/e38518353aff504a0f4cc086e1af9b579f0c5259ecd4c13cc09cd8ba63c27d65.jpeg",
    "https://cdn.faire.com/fastly/ff1a72398810e4b8eee47f4ac4c02b0269c7136d11b3d1bad6a74ab26593b8be.jpeg",
    "https://cdn.faire.com/fastly/45056a1a7bb163e68b8db42b4f7ff195089c3fa4addc2731c22ee5d2519ae04e.jpeg",
    "https://cdn.faire.com/fastly/d64a730e7d7eb3f4621d3a7b8dd2696a4e0fb95fec96b6201aa27b38d1f03397.jpeg",
    "https://cdn.faire.com/fastly/124e363abbeca7a3a0f81555013dc188965b69bfa8441b2a87c4a3fa1d363afb.jpeg",
    "https://cdn.faire.com/fastly/776463a4aa427b97ff94deb9ffeae9f27a8393af3b4a09738b5d6e31ea22de52.jpeg",
    "https://cdn.faire.com/fastly/e94c325781f494e29d3ac2531d979c4f13d8e10c96c07a41922a058842f9f957.jpeg",
    "https://cdn.faire.com/fastly/652fcbefc9bbd5b3a7c95cede1075c2f47f8e71b4632f669f6a342aee8bef75c.jpeg",
    "https://cdn.faire.com/fastly/98f5f3c3da65b46bf4b6160d5664b25366632423777564f19122d68c8e8aa357.jpeg",
  ],
  priceDollars: 15.5,
  description:
    "🎀Material: Nylon\n😍Why You’ll Love It?\n\nA glossy transparent overlay adds a modern and stylish touch to the vibrant striped pattern.\nThe large capacity design provides a spacious interior for all of your daily essentials.\nDurable and easy-to-clean materials ensure this tote bag is both practical and fashionable.\nSturdy handles and a lightweight construction make it comfortable for all-day carrying.\nbag size: 17.3 × 5.1 × 12.2 inches\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:05.537Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
